import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../components/Layout';
import StyledHero from '../components/StyledHero';
import FAQs from '../components/Faqs';

const aboutPage = ({ data }) => {
  return (
    <Layout>
      <StyledHero
        img={data.defaultBcg.childImageSharp.fluid}
        home={false}
        backgroundposition="40% 50%"
      ></StyledHero>
      <FAQs></FAQs>
    </Layout>
  );
};

export const query = graphql`
  query {
    defaultBcg: file(relativePath: { eq: "julie.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1920) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`;

export default aboutPage;
